var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../themes';
import { Typography } from '../Typography';
import * as S from './styles';
/**
 * Links are accessible elements used primarily for navigation.
 *
 * It integrates well with other routing libraries like
 * React Router, Reach Router and Next.js Link.
 *
 * @example
 *
 * ```jsx
 * <Link as={NextLink} href='/home'>Home</Link>
 * ```
 *
 * @default labelTypographyProps that will apply on label props.
 * If you pass children you must style on your own.
 *
 * ```jsx
 * type: 'l2',
 * fontSize: 'xs',
 * fontFamily: 'Poppins',
 * fontWeight: 'bold',
 * color: brand.color.status.neutral1,
 * ```
 */
export var Link = forwardRef(function (props, ref) {
    var isExternal = props.isExternal, label = props.label, devLabelProps = props.labelTypographyProps, devChildren = props.children, rest = __rest(props, ["isExternal", "label", "labelTypographyProps", "children"]);
    var brand = useTheme().brand;
    var labelTypographyProps = __assign({ type: 'l2', fontSize: 'xs', fontFamily: 'Poppins', fontWeight: 'bold', color: brand.color.status.neutral1 }, devLabelProps);
    var children = devChildren;
    if (!children && !!label) {
        children = (_jsx(Typography, __assign({ "data-testid": "link-label" }, labelTypographyProps, { children: label })));
    }
    if (!children) {
        return null;
    }
    return (_jsx(S.Link, __assign({ "data-testid": "link", target: isExternal ? '_blank' : undefined, rel: isExternal ? 'noopener' : undefined, ref: ref }, rest, { children: children })));
});
